/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AdminCheckOrganizationGet$Params {
  companyName?: string;
  urnCompanyId?: string;
}

export function adminCheckOrganizationGet(http: HttpClient, rootUrl: string, params?: AdminCheckOrganizationGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, adminCheckOrganizationGet.PATH, 'get');
  if (params) {
    rb.query('companyName', params.companyName, {});
    rb.query('urnCompanyId', params.urnCompanyId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as OrganizationStrictHttpResponse<void>;
    })
  );
}

adminCheckOrganizationGet.PATH = '/Admin/checkOrganization';
